import * as ReactDOMClient from 'react-dom/client';
import { Main } from "./Main";
import './index.css';

// Render DOM
const container = document.getElementById('root') as HTMLElement;
const root = ReactDOMClient.createRoot(container);
root.render(<Main />);
